import { DEFAULT_THEME_FONT_FAMILY } from '../../web-builder/editorConfig';
import {
  OmpAspectRatio,
  OmpBorderStyle,
  OmpButtonStyle,
  OmpCornerRoundness,
  OmpLogoPosition,
  OmpNavPosition,
  OmpPopupLayout,
} from '../../_models';
import { OmpStyleVar } from '../order-management-portal.sections';

// Default Global Styles form values, keyed by the style-variable names (= reactive-form controls).
export const OmpStyleDefaults: { [key: string]: any } = {
  [OmpStyleVar.Logo]: '',
  [OmpStyleVar.HeaderBackgroundColor]: '#FFFFFF',
  [OmpStyleVar.LogoWidth]: 200,
  [OmpStyleVar.DesktopLogoPosition]: OmpLogoPosition.TopCenter,
  [OmpStyleVar.ShowHeaderSeparatorLine]: true,
  [OmpStyleVar.ThemeColor]: '#5A301C',
  [OmpStyleVar.ButtonTextColor]: '#FFFFFF',
  [OmpStyleVar.ButtonHoverColor]: '#FFFFFF',
  [OmpStyleVar.LinksAndIconsColor]: '#5A301C',
  [OmpStyleVar.CardBackgroundColor]: '#FFFFFF',
  [OmpStyleVar.CardBorderColor]: '#FFFFFF',
  [OmpStyleVar.PageBackgroundColor]: '#FFFFFF',
  [OmpStyleVar.PageBackgroundImage]: '',
  [OmpStyleVar.PageBackgroundImageOpacity]: 100,
  [OmpStyleVar.BodyTextColor]: '#163549',
  [OmpStyleVar.CardCornerRoundness]: OmpCornerRoundness.GentlyRounded,
  [OmpStyleVar.CardBorderStyle]: OmpBorderStyle.Solid,
  [OmpStyleVar.CardBorderThickness]: 1,
  [OmpStyleVar.CardBorderOpacity]: 100,
  [OmpStyleVar.CardShadowOpacity]: 100,
  [OmpStyleVar.CardShadowHorizontalOffset]: 1,
  [OmpStyleVar.CardShadowVerticalOffset]: 1,
  [OmpStyleVar.CardShadowBlur]: 1,
  [OmpStyleVar.ProductImageAspectRatio]: OmpAspectRatio.Portrait,
  [OmpStyleVar.ProductImageCornerRoundness]: OmpCornerRoundness.GentlyRounded,
  [OmpStyleVar.MaxPageWidth]: 1200,
  [OmpStyleVar.MaxContentWidth]: 700,
  [OmpStyleVar.SectionVerticalPadding]: 32,
  [OmpStyleVar.SectionHorizontalPadding]: 32,
  [OmpStyleVar.HeadingFont]: DEFAULT_THEME_FONT_FAMILY,
  [OmpStyleVar.FontFamily]: DEFAULT_THEME_FONT_FAMILY,
  [OmpStyleVar.EnableStickyNavigationalBlocks]: false,
  [OmpStyleVar.NavigationBlocksPosition]: OmpNavPosition.Right,
  [OmpStyleVar.PopupLayout]: OmpPopupLayout.Right,
  [OmpStyleVar.OrderPriceOnListPage]: false,
  [OmpStyleVar.ButtonCornerRoundness]: OmpCornerRoundness.FullyRounded,
  primary_button_style: OmpButtonStyle.Outline,
  primary_button_border_thickness: 1,
  primary_button_border_opacity: 100,
  primary_button_shadow_opacity: 100,
  primary_button_shadow_horizontal_offset: 1,
  primary_button_shadow_vertical_offset: 1,
  primary_button_shadow_blur: 1,
  secondary_button_style: OmpButtonStyle.Fill,
  secondary_button_border_thickness: 1,
  secondary_button_border_opacity: 100,
  secondary_button_shadow_opacity: 100,
  secondary_button_shadow_horizontal_offset: 1,
  secondary_button_shadow_vertical_offset: 1,
  secondary_button_shadow_blur: 1,
  tertiary_button_style: OmpButtonStyle.Text,
  tertiary_button_border_thickness: 1,
  tertiary_button_border_opacity: 100,
  tertiary_button_shadow_opacity: 100,
  tertiary_button_shadow_horizontal_offset: 1,
  tertiary_button_shadow_vertical_offset: 1,
  tertiary_button_shadow_blur: 1,
};

export const OmpBrandOwnedStyleVars: string[] = [
  OmpStyleVar.ThemeColor,
  OmpStyleVar.ButtonHoverColor,
  OmpStyleVar.FontFamily,
];
